import React from "react";
import { DraftContext } from "@/shared/contexts/DraftContext/DraftContext";
import { useDraftProvider } from "@/shared/contexts/DraftContext/useDraftProvider";

type DraftContextProviderProps = { children: React.ReactNode };

export const DraftContextProvider: React.FC<DraftContextProviderProps> = ({ children }) => {
  const draftContextValue = useDraftProvider();

  return (
    <DraftContext.Provider value={draftContextValue}>
      {children}
    </DraftContext.Provider>
  );
};
